export { default } from './DidNotFindExpandablePanel';



// WEBPACK FOOTER //
// ./app/components/search/DidNotFindExpandablePanel/index.js